const transfers = {
  transfer: "Transfer", // translated 
  transfers: "Transfer", // translated 
  dateAndTime: "Tanggal dan waktu", // translated 
  transferFrom: "Transfer Dari", // translated 
  duration: "Durasi", // translated 
  numOfPersons: "Jumlah orang", // translated 
  baggageAllowance: "Tunjangan Bagasi", // translated 
  small: "Kecil", // translated 
  big: "Besar", // translated 
  provider: "Pemberi", // translated 
  vehicle: "Kendaraan", // translated 
  distance: "Jarak", // translated 
  price: "Harga", // translated 
  inboundJourney: "Perjalanan Masuk", // translated 
  outboundJourney: "Perjalanan Keluar", // translated 
  arrivalTime: "Jam kedatangan", // translated 
  flightDetails: "Detail penerbangan", // translated 
  inboundPickupDate: "Tanggal Pengambilan Masuk", // translated 
  outboundPickupDate: "Tanggal Penjemputan Keluar", // translated 
  travelInfo: "Info Perjalanan", // translated 
  flightsInfo: "Info Penerbangan", // translated 
  airportYouAreFlyingFrom: "Bandara tempat Anda terbang", // translated 
  airportYouAreFlyingTo: "Bandara tujuan penerbangan Anda", // translated 
  inboundFlightNumber: "Nomor Penerbangan Masuk", // translated 
  outboundFlightNumber: "Nomor Penerbangan Keluar", // translated 
  inboundAirlineName: "Nama Maskapai Masuk", // translated 
  outboundAirlineName: "Nama Maskapai Keluar", // translated 
  tripMode: "Modus Perjalanan", // translated 
  airportToPoint: "Bandara Ke Titik", // translated 
  pointToAirport: "Arahkan ke Bandara", // translated 
  roundTrip: "Perjalanan pulang pergi", // translated 
  destinationPoint: "Titik Tujuan", // translated 
  originPoint: "Titik Asal", // translated 
  transferType: "Jenis Pemindahan", // translated 
  min: "Minimal", // translated 
  max: "Maks", // translated 
  pieces: "Bagian-bagian", // translated 
  cancelationIs: "pembatalan adalah", // translated 
};



export default transfers;
